export default __webpack_public_path__ + "static/media/phone.3ac95e91.svg";